import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'src/app/core/services/shared.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { AuthService } from 'src/app/core/services/auth.service'
import { ClaimsService } from 'src/app/core/services/claims.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { Result } from '@zxing/library';

@Component({
  selector: 'doctors-list-dialog',
  templateUrl: 'doctors-list-dialog.component.html',
  styleUrls: ['doctors-list-dialog.component.scss']
})

export class DoctorsListDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DoctorsListDialogComponent>,
    private sharedService: SharedService,
    private profileService: ProfileService,
    private claimsService: ClaimsService,
    private authService: AuthService
  ) { }

  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = ['visitingDays', 'visitingHoursStart', 'visitingHoursEnd'];
  resultsLength = 0;
  @ViewChild(MatPaginator) doctorDetailsPaginator: MatPaginator | undefined;

  specialityTypes: Array<any> = [];
  types: Array<any> = [];
  doctorProviderDetailsDto: any = [];
  days: Array<any> = [
    { day: 'Monday', isSelected: false },
    { day: 'Tuesday', isSelected: false },
    { day: 'Wednesday', isSelected: false },
    { day: 'Thursday', isSelected: false },
    { day: 'Friday', isSelected: false },
    { day: 'Saturday', isSelected: false },
    { day: 'Sunday', isSelected: false }
  ];
  visitingHours: Array<any> = [, , , , , , ,];
  visitingHoursStart: Array<any> = [, , , , , , ,];
  visitingHoursEnd: Array<any> = [, , , , , , ,];
  isShowCopyButton: Array<any> = [, , , , , , ,];
  visitView: Array<any> = [];
  invalidShiftTime = false;

  addDoctorForm = new FormGroup({
    doctorName: new FormControl('', [Validators.required, Validators.pattern('^[\.a-zA-Z0-9 ]*$')]),
    registrationNumber: new FormControl('', Validators.required),
    highestEducation: new FormControl(''),
    speciality: new FormControl(''),
    doctorType: new FormControl('', Validators.required),
    visitingDays: new FormControl(''),
    doctorEmail: new FormControl('', [Validators.pattern("[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}")]),
    doctorContact: new FormControl('', [Validators.pattern('^[6-9]\\d{9}$')]),
  });

  ngOnInit(): void {
    this.getDoctorTypes();
    this.getTreatmentTypes();
    if (this.data.mode === 'Edit') {
      this.fillEditDetails();
    }
    if (this.data.mode === 'View') {
      this.fillViewDetails();
    }
  }

  switchDay(day: any) {
    if (day.isSelected === false) {
      day.isSelected = true
    } else {
      day.isSelected = false
    }
  }

  trackByIdx(index: number, obj: any): any {
    return index;
  }

  showCopyButton(queryNumber: any){
    if(this.visitingHoursStart[queryNumber] && this.visitingHoursEnd[queryNumber]){
       this.isShowCopyButton[queryNumber]=true;
     }    
   }
 
   copyVisitingTime(queryNumber: any){
       this.days.forEach((day, index) => {
         this.visitingHoursStart[index] = this.visitingHoursStart[queryNumber];
         this.visitingHoursEnd[index] = this.visitingHoursEnd[queryNumber];
         this.isShowCopyButton[index]=true;
     });
     
   }

  minutesOfDay = function (m: any) {
    let result: any
    if (m != undefined) {
      let time = m.split(":");
      result = parseInt(time[1]) + parseInt(time[0]) * 60;
    }
    return result;
  }

  getDoctorTypes() {
    this.sharedService.getDoctorType().subscribe(
      (res: any) => {
        this.types = res.body;
      },
      (err: any) => {
        Swal.fire('', err.error.message ? err.error.message : err.message, 'error');
      }
    );
  }

  getTreatmentTypes() {
    this.sharedService.getDoctorSpeciality().subscribe(
      (res: any) => {
        this.specialityTypes = res.body;
      },
      (err: any) => {
      }
    );
  }

  fillEditDetails() {
    this.addDoctorForm.controls['doctorName'].setValue(this.data.editData.doctorName);
    this.addDoctorForm.controls['registrationNumber'].setValue(this.data.editData.registrationNumber);
    this.addDoctorForm.controls['highestEducation'].setValue(this.data.editData.highestEducation);
    this.addDoctorForm.controls['speciality'].setValue(this.data.editData.speciality);
    this.addDoctorForm.controls['doctorType'].setValue(this.data.editData.doctorType);
    this.addDoctorForm.controls['doctorEmail'].setValue(this.data.editData.email);
    this.addDoctorForm.controls['doctorContact'].setValue(this.data.editData.contactNo);
    this.addDoctorForm.controls['visitingDays'].setValue(this.data.editData.visitingDays);
    for (let i = 0; i < this.data.editData.visitingDays.length; i += 1) {
      let daysControl = [];
      if (this.data.editData.visitingDays[i] != "null") {
        if (this.data.editData.visitingDays[i] === 'Monday') {
          this.days[0].isSelected = true;
          const parts = this.data.editData.visitingHours[i].split("-");
          this.visitingHoursStart.splice(0, 1, parts[0]);
          this.visitingHoursEnd.splice(0, 1, parts[1]);
          daysControl.push(this.data.editData.visitingDays[i].day);
        } else if (this.data.editData.visitingDays[i] === 'Tuesday') {
          this.days[1].isSelected = true;
          const parts = this.data.editData.visitingHours[i].split("-");
          this.visitingHoursStart.splice(1, 1, parts[0]);
          this.visitingHoursEnd.splice(1, 1, parts[1]);
        } else if (this.data.editData.visitingDays[i] === 'Wednesday') {
          this.days[2].isSelected = true;
          const parts = this.data.editData.visitingHours[i].split("-");
          this.visitingHoursStart.splice(2, 1, parts[0]);
          this.visitingHoursEnd.splice(2, 1, parts[1]);
        } else if (this.data.editData.visitingDays[i] === 'Thursday') {
          this.days[3].isSelected = true;
          const parts = this.data.editData.visitingHours[i].split("-");
          this.visitingHoursStart.splice(3, 1, parts[0]);
          this.visitingHoursEnd.splice(3, 1, parts[1]);
        } else if (this.data.editData.visitingDays[i] === 'Friday') {
          this.days[4].isSelected = true;
          const parts = this.data.editData.visitingHours[i].split("-");
          this.visitingHoursStart.splice(4, 1, parts[0]);
          this.visitingHoursEnd.splice(4, 1, parts[1]);
        } else if (this.data.editData.visitingDays[i] === 'Saturday') {
          this.days[5].isSelected = true;
          const parts = this.data.editData.visitingHours[i].split("-");
          this.visitingHoursStart.splice(5, 1, parts[0]);
          this.visitingHoursEnd.splice(5, 1, parts[1]);
        } else if (this.data.editData.visitingDays[i] === 'Sunday') {
          this.days[6].isSelected = true;
          const parts = this.data.editData.visitingHours[i].split("-");
          this.visitingHoursStart.splice(6, 1, parts[0]);
          this.visitingHoursEnd.splice(6, 1, parts[1]);
        }
      }
    }
  }

  fillViewDetails() {
    this.dataSource = new MatTableDataSource<any>();
    this.dataSource.paginator = null;
    let visitingDaysView = [];
    let visitingHoursStartView = [];
    let visitingHoursEndView = [];
    if (this.data.editData != null) {
      for (let i = 0; i < this.data.editData.visitingDays.length; i += 1) {
        if (this.data.editData.visitingDays[i] != "null") {
          const parts = this.data.editData.visitingHours[i].split("-");
          visitingHoursStartView.push(parts[0]);
          visitingHoursEndView.push(parts[1]);
          visitingDaysView.push(this.data.editData.visitingDays[i]);
        }
      }
      for (let i = 0; i < visitingDaysView.length; i += 1) {
        let submitObj = {
          visitingDays: visitingDaysView[i],
          visitingHoursStart: visitingHoursStartView[i],
          visitingHoursEnd: visitingHoursEndView[i]
        }
        this.visitView.push(submitObj);
      }
      this.dataSource = new MatTableDataSource<any>(this.visitView);
      this.dataSource.paginator = this.doctorDetailsPaginator!;
      this.resultsLength = this.visitView.length;
    }
  }

  getDoctorDetails(queryNumber: any, type: any) {
    if (queryNumber && type) {
      this.sharedService
        .fetchDoctorDetails(queryNumber, type)
        .subscribe((res: any) => {
          if (res.body != null) {
            if (res.body.doctorProviderMapping?.length > 0) {
              var visitingDays = [];
              var visitingHours = [];
              var providerBranchProfId: any;
              var doctorType: any;
              for (let providerEntry of res.body.doctorProviderMapping) {
                visitingDays.push(providerEntry.visitingDays);
                visitingHours.push(providerEntry.visitingHours);
                providerBranchProfId = providerEntry.providerBranchProfile?.id;
                doctorType = providerEntry.doctorType;

                for (let i = 0; i < visitingDays.length; i += 1) {
                  let daysControl = [];
                  if (visitingDays[i] != "null") {
                    if (visitingDays[i] === 'Monday') {
                      this.days[0].isSelected = true;
                      const parts = visitingHours[i].split("-");
                      this.visitingHoursStart.splice(0, 1, parts[0]);
                      this.visitingHoursEnd.splice(0, 1, parts[1]);
                      daysControl.push(visitingDays[i]);
                    } else if (visitingDays[i] === 'Tuesday') {
                      this.days[1].isSelected = true;
                      const parts = visitingHours[i].split("-");
                      this.visitingHoursStart.splice(1, 1, parts[0]);
                      this.visitingHoursEnd.splice(1, 1, parts[1]);
                      daysControl.push(visitingDays[i]);
                    } else if (visitingDays[i] === 'Wednesday') {
                      this.days[2].isSelected = true;
                      const parts = visitingHours[i].split("-");
                      this.visitingHoursStart.splice(2, 1, parts[0]);
                      this.visitingHoursEnd.splice(2, 1, parts[1]);
                      daysControl.push(visitingDays[i]);
                    } else if (visitingDays[i] === 'Thursday') {
                      this.days[3].isSelected = true;
                      const parts = visitingHours[i].split("-");
                      this.visitingHoursStart.splice(3, 1, parts[0]);
                      this.visitingHoursEnd.splice(3, 1, parts[1]);
                      daysControl.push(visitingDays[i]);
                    } else if (visitingDays[i] === 'Friday') {
                      this.days[4].isSelected = true;
                      const parts = visitingHours[i].split("-");
                      this.visitingHoursStart.splice(4, 1, parts[0]);
                      this.visitingHoursEnd.splice(4, 1, parts[1]);
                      daysControl.push(visitingDays[i]);
                    } else if (visitingDays[i] === 'Saturday') {
                      this.days[5].isSelected = true;
                      const parts = visitingHours[i].split("-");
                      this.visitingHoursStart.splice(5, 1, parts[0]);
                      this.visitingHoursEnd.splice(5, 1, parts[1]);
                      daysControl.push(visitingDays[i]);
                    } else if (visitingDays[i] === 'Sunday') {
                      this.days[6].isSelected = true;
                      const parts = visitingHours[i].split("-");
                      this.visitingHoursStart.splice(6, 1, parts[0]);
                      this.visitingHoursEnd.splice(6, 1, parts[1]);
                      daysControl.push(visitingDays[i]);
                    }
                  }
                }
              }
              this.addDoctorForm.controls['doctorName'].setValue(res.body.doctorDetails?.doctorName);
              this.addDoctorForm.controls['highestEducation'].setValue(res.body.doctorDetails?.education);
              this.addDoctorForm.controls['speciality'].setValue(res.body.doctorDetails?.speciality);
              this.addDoctorForm.controls['doctorType'].setValue(doctorType);
              this.addDoctorForm.controls['doctorEmail'].setValue(res.body.doctorDetails?.emailId);
              this.addDoctorForm.controls['doctorContact'].setValue(res.body.doctorDetails?.phoneNumber);
              this.addDoctorForm.controls['registrationNumber'].setValue(res.body.doctorDetails?.registrationNumber);
              this.addDoctorForm.controls['visitingDays'].setValue(visitingDays);

              if (type === 'phoneNum') {
                this.addDoctorForm.controls['registrationNumber'].disable();
              } else if (type === 'registrationNum') {
                this.addDoctorForm.controls['doctorContact'].disable();
              }
            }
          } else {
            this.addDoctorForm.controls['doctorName'].reset();
            this.addDoctorForm.controls['highestEducation'].reset();
            this.addDoctorForm.controls['speciality'].reset();
            this.addDoctorForm.controls['doctorType'].reset();
            this.addDoctorForm.controls['doctorEmail'].reset();
            this.addDoctorForm.controls['visitingDays'].reset();
            if (type === 'phoneNum') {
              this.addDoctorForm.controls['registrationNumber'].enable();
            } else if (type === 'registrationNum') {
              this.addDoctorForm.controls['doctorContact'].enable();
            }
            this.visitingHoursStart = [, , , , , , ,];
            this.visitingHoursEnd = [, , , , , , ,];
            for (let day of this.days) {
              day.isSelected = false;
            }
          }
        }, error => {
          this.addDoctorForm.controls['doctorName'].reset();
          this.addDoctorForm.controls['highestEducation'].reset();
          this.addDoctorForm.controls['speciality'].reset();
          this.addDoctorForm.controls['doctorType'].reset();
          this.addDoctorForm.controls['doctorEmail'].reset();
          this.addDoctorForm.controls['visitingDays'].reset();
          if (type === 'phoneNum') {
            this.addDoctorForm.controls['registrationNumber'].enable();
          } else if (type === 'registrationNum') {
            this.addDoctorForm.controls['doctorContact'].enable();
          }
          this.visitingHoursStart = [, , , , , , ,];
          this.visitingHoursEnd = [, , , , , , ,];
          for (let day of this.days) {
            day.isSelected = false;
          }
        });
    }
  }

  addDoctor() {
    let submitDays: Array<any> = [];
    for (let i = 0; i < this.days.length; i += 1) {
      if (this.days[i].isSelected === true) {
        let spliceObj = {
          visitingDay: this.days[i].day,
          visitingStartTime: this.visitingHoursStart[i],
          visitingEndTime: this.visitingHoursEnd[i]
        }
        submitDays.push(spliceObj);
      }
    }

    let newObj: any = {
      visitingDetails: submitDays,
      doctorType: this.addDoctorForm.value.doctorType
    };
    this.doctorProviderDetailsDto = [];
    this.doctorProviderDetailsDto.push(newObj);

    //Creating final SubmitData object 
    let submitData = {
      doctorName: this.addDoctorForm.value.doctorName,
      registrationNumber: this.addDoctorForm.getRawValue().registrationNumber,
      education: this.addDoctorForm.value.highestEducation,
      phoneNo: this.addDoctorForm.getRawValue().doctorContact,
      email: this.addDoctorForm.value.doctorEmail,
      speciality: this.addDoctorForm.value.speciality,
      proBranchProfId: this.authService.currentUserValue.providerBranchProfile.id,
      doctorProviderDetailsDto: this.doctorProviderDetailsDto
    }

    this.sharedService.addDoctor(submitData).subscribe(
      (res: any) => {
        if (res.status === 208) {
          Swal.fire('', res.message ? res.message : res.message, 'error');
        } else {
          Swal.fire('', 'Doctor Added Successfully', 'success');
          this.dialogRef.close('success');
        }
      },
      (err: any) => {
        Swal.fire('', err ? err : err, 'error');
      }
    );
  }

  editDoctor() {
    let submitDays: Array<any> = [];
    for (let i = 0; i < this.days.length; i += 1) {
      if (this.days[i].isSelected === true) {
        let spliceObj = {
          visitingDay: this.days[i].day,
          visitingStartTime: this.visitingHoursStart[i],
          visitingEndTime: this.visitingHoursEnd[i]
        }
        submitDays.push(spliceObj);
      }
    }

    let newObj: any = {
      visitingDetails: submitDays,
      doctorType: this.addDoctorForm.value.doctorType
    };
    this.doctorProviderDetailsDto = [];
    this.doctorProviderDetailsDto.push(newObj);
    //Creating final SubmitData object 
    let submitData = {
      doctorName: this.addDoctorForm.value.doctorName,
      registrationNumber: this.addDoctorForm.value.registrationNumber,
      education: this.addDoctorForm.value.highestEducation,
      doctorId: this.data.editData.doctorId,
      phoneNo: this.addDoctorForm.value.doctorContact,
      email: this.addDoctorForm.value.doctorEmail,
      speciality: this.addDoctorForm.value.speciality,
      proBranchProfId: this.data.editData.providerBranchProfileId,
      doctorProviderDetailsDto: this.doctorProviderDetailsDto
    }

    this.sharedService.editDoctor(submitData).subscribe(
      (res: any) => {
        Swal.fire('', 'Details Saved Successfully', 'success');
        this.dialogRef.close('success');
      },
      (err: any) => {
        Swal.fire('', err ? err : err, 'error');
      }
    );
  }
}